export default class ItemEventChangeValueTypeDomainService {
    static get STRING_ID() {
        return 1;
    }
    static get NOTE_TYPE_ID() {
        return 2;
    }
    static get ITEM_STATUS_ID() {
        return 3;
    }
    static get PERSON_ID() {
        return 4;
    }
    static get TASK_STATUS_ID() {
        return 5;
    }
    static get TASK_PRIORITY_ID() {
        return 6;
    }
    static get DATE_ID() {
        return 7;
    }
    static get NUMBER_ID() {
        return 8;
    }
    static get BOOLEAN_ID() {
        return 9;
    }
    static get HTML_ID() {
        return 10;
    }
}
